var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0161 0.00132394C21.6107 0.0156326 21.2387 0.230258 21.0241 0.573658L9.53924 18.1443L2.0989 11.7151C1.77935 11.3836 1.30002 11.2596 0.858843 11.3979C0.420054 11.5339 0.0933471 11.9059 0.0170359 12.359C-0.0592753 12.8145 0.124348 13.2723 0.496365 13.5466L9.00506 20.9106C9.27215 21.1371 9.62509 21.2373 9.97088 21.1872C10.319 21.1348 10.6267 20.9368 10.8175 20.6435L23.0845 1.9091C23.3468 1.52516 23.3683 1.02914 23.1417 0.623737C22.9152 0.220719 22.4788 -0.0201384 22.0161 0.00132394Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d942aeded7d478e4a83374ac49f55c49.svg";
export { ForwardRef as ReactComponent };